import { ExpandedColumn, Filter } from "../types/columns";

export const hydrateColumn = ({
  column,
  defaultColumns,
}: {
  column: ExpandedColumn;
  defaultColumns: ExpandedColumn[];
}) => {
  // A key listed in DEFAULT_COLUMNS without a column definition yields an
  // undefined column; skip it instead of crashing the whole page.
  if (!column) return null;
  const defaultCol = defaultColumns?.find((dc) => dc.key === column.key);
  if (!defaultCol) return null;
  const mappedCol = { ...column };

  if (defaultCol.filter) {
    if (!mappedCol.filter) {
      mappedCol.filter = defaultCol.filter;
    } else {
      mappedCol.filter = {
        ...defaultCol.filter,
        ...mappedCol.filter,
      } as Filter;
    }
  }

  if (mappedCol.filter && mappedCol.filter.type === "date") {
    if (mappedCol.filter.date1) {
      mappedCol.filter.date1 = new Date(mappedCol.filter.date1);
    }
    if (mappedCol.filter.date2) {
      mappedCol.filter.date2 = new Date(mappedCol.filter.date2);
    }
  }

  mappedCol.onRender = defaultCol.onRender;
  mappedCol.excel = defaultCol.excel;
  return mappedCol;
};
